// extracted by mini-css-extract-plugin
export default {"wrapper":"An-z","response":"Bn-z","error":"Cn-z","disabled":"Dn-z","buttons":"En-z","feedbackQuestionSection":"Fn-z","yesNoWrapper":"Gn-z"};